import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1To80 extends React.PureComponent {
  static minValue = 1;
  static maxValue = 80;

  static describeRank = rank => rank.toString();
  static getDefaultValue = () => [70, 80];

  static marks = {
    1: '1',
    10: '10',
    20: '20',
    30: '30',
    40: '40',
    50: '50',
    60: '60',
    70: '70',
    80: '80',
  };

  render() {
    const { ...rest } = this.props;

    return (
      <LevelingRankPicker
        {...rest}
        min={Leveling1To80.minValue}
        max={Leveling1To80.maxValue}
        marks={Leveling1To80.marks}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1To80.js